import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getRelatedPosts } from "../../redux/features/post/postSlice";
import "./RelatedPosts.scss";

const RelatedPosts = () => {
  // const { id } = useParams();
  const { identifier } = useParams();

  const dispatch = useDispatch();
  useEffect(() => {
    if (identifier) {
      dispatch(getRelatedPosts(identifier));
    }
  }, [dispatch, identifier]);

  const { relatedPosts, isLoading } = useSelector((state) => state.post);

  const related = relatedPosts
    ?.filter((post) => {
      return post;
    })
    ?.filter((post, index) => index < 5);

  return (
    <div className="related-posts">
      <h3>Related Posts</h3>
      <ul className="related-posts__list">
        {related && related.length > 0
          ? related.map((post) => (
              <li className="related-posts__item" key={post._id}>
                <Link to={`/page/${post.slug}`} className="related-posts__link">
                  {post.title}
                </Link>
              </li>
            ))
          : !isLoading && (
              <p className="related-posts__empty">No related posts found.</p>
            )}
      </ul>
    </div>
  );
};
export default RelatedPosts;
